import { AvatarGroupProps } from "./interfaces";
import {
  StyledAvatarGroup,
  StyledAvatar,
  StyledTooltip,
  StyledTotalNumAvatar,
} from "./styles";

export const AvatarGroup = (props: AvatarGroupProps) => {
  return (
    <StyledAvatarGroup size={props.size ? props.size : 24}>
      {props.entities?.map((entity: any, index: number) => (
        <StyledTooltip title={entity.fullName} key={index}>
          <StyledAvatar>{entity.fullName[0] || ""}</StyledAvatar>
        </StyledTooltip>
      ))}

      {props.numAcountsHidden > 0 && (
        <StyledTotalNumAvatar>+{props.numAcountsHidden}</StyledTotalNumAvatar>
      )}
    </StyledAvatarGroup>
  );
};
